import Modal from "@root/shared/components/Modal";
import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import { UserDetailContents } from "@clientFrontend/features/scout/components/UserDetailContents";
import { type UserDetails } from "@clientFrontend/features/scout/types/userDetails";
import { type UserHiddenButtonContent } from "@clientFrontend/features/scout/types/userHidden";
import * as styles from "./styles.css";

type Props = {
  formattedData: UserDetails & UserDetailModalSpFooterContentsProps;
  isShow: boolean;
  onClose: () => void;
  isShowScoutNavigation: boolean;
  userHiddenButtonContent: UserHiddenButtonContent;
};

type UserDetailModalSpFooterContentsProps = {
  gaEvents: {
    scout: {
      gaAction: string;
      gaLabel: string;
    };
    premiumScout: {
      gaAction: string;
      gaLabel: string;
    };
  };
  scoutButtonContent: {
    scoutUrl: string;
    premiumScoutUrl: string;
  };
};

export const Presentation: FC<Props> = ({
  formattedData,
  isShow,
  onClose,
  isShowScoutNavigation,
  userHiddenButtonContent,
}) => {
  return (
    <Modal
      headerTitle="プロフィール詳細"
      isShow={isShow}
      onClose={onClose}
      spAppearanceType="bottom"
      footerContent={
        isShowScoutNavigation && !formattedData.displayControlInformation.isNotScoutable
          ? footerContents(formattedData)
          : null
      }
      footerContentStyle={
        isShowScoutNavigation && !formattedData.displayControlInformation.isNotScoutable
          ? "button"
          : "none"
      }
    >
      <UserDetailContents
        labels={formattedData.labels}
        displayControlInformation={formattedData.displayControlInformation}
        userData={formattedData.userData}
        historyInformation={formattedData.historyInformation}
        hopedConditions={formattedData.hopedConditions}
        userProfileInformation={formattedData.userProfileInformation}
        userHiddenButtonContent={userHiddenButtonContent}
      />
    </Modal>
  );
};

const footerContents: FC<UserDetailModalSpFooterContentsProps> = ({
  scoutButtonContent,
  gaEvents,
}) => (
  <div className={styles.btnArea}>
    {scoutButtonContent.premiumScoutUrl && (
      <Link
        href={scoutButtonContent.premiumScoutUrl}
        theme="primary"
        className={styles.button}
        data-ga-action={gaEvents.premiumScout.gaAction}
        data-ga-label={gaEvents.premiumScout.gaLabel}
      >
        プレミアムスカウト
      </Link>
    )}
    {scoutButtonContent.scoutUrl && (
      <Link
        href={scoutButtonContent.scoutUrl}
        theme="secondary"
        className={styles.button}
        data-ga-action={gaEvents.scout.gaAction}
        data-ga-label={gaEvents.scout.gaLabel}
      >
        スカウト
      </Link>
    )}
  </div>
);
